import { useEffect } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, FormLabel, Stack, TextField, Button } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Add } from "@mui/icons-material";
import PageTitle from "../../common/PageTitle";
import debounceHandler from "../../helpers/utils/debounceHandler";
import { COMPANY_STATUS_LIST } from "../../helpers/constant/coreConstant";
import { selectCompanyListState } from "../../state/companyList/companyListSelector";
import { updateCompanyListFilters } from "../../state/companyList/companyListSlice";
import useBoolean from "../../hooks/useBoolean";
import BasicModalWithHeader from "../../global/Modal/BasicModalWithHeader";
import AddCompanyForm from "./AddCompanyForm";

const AllOptionObj = { "": { value: "", label: "All" } };

const CompaniesHeader = () => {
  const dispatch = useDispatch();
  const companyStatusOptions = { ...AllOptionObj, ...COMPANY_STATUS_LIST };
  const { filters } = useSelector(selectCompanyListState);
  const { ownerEmail, companyName } = filters || {};
  const { value: openDrawer, setTrue: onOpenDrawer, setFalse: onCloseDrawer } = useBoolean(false);

  const handleOwnerEmailSearch = debounceHandler((e) => {
    const { value } = e.target || {};
    dispatch(updateCompanyListFilters({ ownerEmail: value }));
  }, 1000);

  const handleCompanySearch = debounceHandler((e) => {
    const { value } = e.target || {};
    dispatch(updateCompanyListFilters({ companyName: value }));
  }, 1000);

  const handleChangeStatus = (newValue) => {
    dispatch(updateCompanyListFilters({ status: newValue.value }));
  };

  // reset filters
  useEffect(() => {
    return () => {
      dispatch(
        updateCompanyListFilters({
          ownerEmail: "",
          companyName: "",
          status: "",
        })
      );
    };
  }, []);

  return (
    <>
      <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} justifyContent={"space-between"} spacing={2} mb={3}>
        <PageTitle title={"Companies"} mb={0} subTitleMb={0} />
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "flex-end" }} sx={{ width: { xs: "100%", md: "auto" } }}>
          <FormControl sx={{ flexGrow: 1, minWidth: { xs: "100%", sm: 200 }, maxWidth: { md: 300 } }}>
            <FormLabel>Search By Company Name:</FormLabel>
            <TextField
              size={"small"}
              type={"search"}
              placeholder={"Search by company name"}
              defaultValue={companyName}
              onChange={handleCompanySearch}
              InputProps={{
                startAdornment: <SearchRoundedIcon fontSize={"small"} color={"action"} sx={{ ml: 1 }} />,
              }}
            />
          </FormControl>
          <FormControl sx={{ flexGrow: 1, minWidth: { xs: "100%", sm: 200 }, maxWidth: { md: 200 } }}>
            <FormLabel>Filter By Company Status:</FormLabel>
            <Select
              className={"select-dropdown-menu select-dropdown-menu-custom"}
              classNamePrefix={"select-dropdown-styles"}
              isMulti={false}
              isSearchable={false}
              menuPlacement="bottom"
              options={Object.values(companyStatusOptions)}
              onChange={(newValue) => handleChangeStatus(newValue)}
            />
          </FormControl>
          <Button variant={"contained"} startIcon={<Add />} onClick={onOpenDrawer} sx={{ height: 40 }}>
            Add New Account
          </Button>
        </Stack>
      </Stack>

      <BasicModalWithHeader title={"Add New Company Account"} open={openDrawer} onClose={onCloseDrawer} width={550}>
        <AddCompanyForm onClose={onCloseDrawer} />
      </BasicModalWithHeader>
    </>
  );
};

export default CompaniesHeader;
